import Swiper from 'swiper'
import { Navigation, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'

class Home {
  constructor() {
    let cache = {};
    let heroSwiper = null;

    let initFunc = () => {
      initCache();
      initHeroSlider();
      initAdvantagesCardsScroll();
      initProaxysToggles();
      registerEvents();
    }

    let initCache = () => {
      cache.page = document.querySelector('.template-home');
      cache.heroSlider = document.querySelector('.hero-swiper');
      cache.heroSocials = document.querySelector('.hero-socials');
      cache.prevButton = document.querySelector('.hero-nav-prev');
      cache.nextButton = document.querySelector('.hero-nav-next');
      cache.advantagesCardsGrid = document.querySelector('.advantages-cards-grid');
      cache.advantagesNavPrev = document.querySelector('.advantages-nav-prev');
      cache.advantagesNavNext = document.querySelector('.advantages-nav-next');
      cache.proaxysElements = document.querySelectorAll('.proaxys-element');
    };

    let initHeroSlider = () => {
      if (!cache.heroSlider) return;

      heroSwiper = new Swiper(cache.heroSlider, {
        modules: [Navigation, Autoplay],
        slidesPerView: 1,
        speed: 800,
        loop: false,
        autoplay: {
          delay: 4500,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        navigation: {
          nextEl: '.hero-nav-next',
          prevEl: '.hero-nav-prev',
        },
        on: {
          init: function() {
            // Masquer les réseaux sociaux sur toutes les slides sauf la première
            updateSocialsVisibility(this.activeIndex);
          },
          slideChange: function() {
            // Masquer les réseaux sociaux si on n'est pas sur la première slide
            updateSocialsVisibility(this.activeIndex);
          },
          reachEnd: function() {
            // Arrêter l'autoplay quand on arrive à la fin
            this.autoplay.stop();
          }
        }
      });
    };

    let updateSocialsVisibility = (activeIndex) => {
      if (!cache.heroSocials) return;

      if (activeIndex === 0) {
        cache.heroSocials.style.opacity = '1';
        cache.heroSocials.style.pointerEvents = 'all';
      } else {
        cache.heroSocials.style.opacity = '0';
        cache.heroSocials.style.pointerEvents = 'none';
      }
    };

    let initAdvantagesCardsScroll = () => {
      if (!cache.advantagesCardsGrid || !cache.advantagesNavPrev || !cache.advantagesNavNext) return;

      // Fonction pour scroller d'une card
      const scrollOneCard = (direction) => {
        const card = cache.advantagesCardsGrid.querySelector('.advantage-card');
        if (!card) return;

        const cardWidth = card.offsetWidth;
        const gap = 20;
        const scrollAmount = cardWidth + gap;

        if (direction === 'next') {
          cache.advantagesCardsGrid.scrollBy({
            left: scrollAmount,
            behavior: 'smooth'
          });
        } else {
          cache.advantagesCardsGrid.scrollBy({
            left: -scrollAmount,
            behavior: 'smooth'
          });
        }
      };

      // Fonction pour mettre à jour l'état des boutons
      const updateButtonsState = () => {
        const scrollLeft = cache.advantagesCardsGrid.scrollLeft;
        const maxScroll = cache.advantagesCardsGrid.scrollWidth - cache.advantagesCardsGrid.clientWidth;

        if (scrollLeft <= 0) {
          cache.advantagesNavPrev.classList.add('disabled');
        } else {
          cache.advantagesNavPrev.classList.remove('disabled');
        }

        if (scrollLeft >= maxScroll - 1) {
          cache.advantagesNavNext.classList.add('disabled');
        } else {
          cache.advantagesNavNext.classList.remove('disabled');
        }
      };

      cache.advantagesNavPrev.addEventListener('click', () => scrollOneCard('prev'));
      cache.advantagesNavNext.addEventListener('click', () => scrollOneCard('next'));

      cache.advantagesCardsGrid.addEventListener('scroll', updateButtonsState);

      updateButtonsState();
    };

    let initProaxysToggles = () => {
      if (!cache.proaxysElements || cache.proaxysElements.length === 0) return;

      cache.proaxysElements.forEach(element => {
        const toggle = element.querySelector('.proaxys-element-toggle');
        const header = element.querySelector('.proaxys-element-header');

        if (!toggle || !header) return;

        header.addEventListener('click', (e) => {
          e.preventDefault();

          cache.proaxysElements.forEach(otherElement => {
            if (otherElement !== element && otherElement.classList.contains('is-open')) {
              otherElement.classList.remove('is-open');
            }
          });

          element.classList.toggle('is-open');
        });
      });
    };

    let registerEvents = () => {
    };

    initFunc();
  };
}
export { Home }
